import React from 'react';
import { components } from 'react-select';

function PlanPickerInput(props) {
    /*
        Setting autoComplete to "off" and type to "search" seems to disable
        the browser autofill menu. See:

        - https://github.com/JedWatson/react-select/issues/3500
        - https://github.com/JedWatson/react-select/issues/3500#issuecomment-1246638994
    */
    return <components.Input {...props} autoComplete="off" type="search" />;
}

export default PlanPickerInput;
